import type { CSSProperties } from 'react';
import type { BoxLayout, ComponentMetaInput } from '../../ui';

export const ACCOUNT_COMPONENTS: ComponentMetaInput[] = [
  { id: 'account.history', page: 'account', role: 'container', label: '完整流水、用量与备份流水', layout: { x: 16, y: 400, width: 358, height: 300 }, zIndex: 2, notes: '按账户分页读取完整历史，切换页面清除旧数据；备份流水为只读本地快照，价格和扣费取历史快照' },
  { id: 'account.root', page: 'account', role: 'container', label: '账户页', layout: { x: 0, y: 24, width: 390, height: 744 }, zIndex: 1, notes: '安卓用 Fragment 根容器；内容可滚动' },
  { id: 'account.header', page: 'account', role: 'container', label: '账户页头部', layout: { x: 0, y: 24, width: 390, height: 56 }, zIndex: 2, notes: '安卓用 MaterialToolbar' },
  { id: 'account.title', page: 'account', role: 'text', label: '账户标题', layout: { x: 16, y: 36, width: 250, height: 32 }, zIndex: 3, notes: '安卓用 Toolbar 标题 TextView' },
  { id: 'account.form', page: 'account', role: 'container', label: '账户表单', layout: { x: 16, y: 104, width: 358, height: 300 }, zIndex: 2, notes: '安卓用 ScrollView 内的表单容器' },
  { id: 'account.balanceCard', page: 'account', role: 'container', label: '余额卡片', layout: { x: 16, y: 104, width: 358, height: 132 }, zIndex: 2, notes: '安卓用 CardView，展示栀籽余额' },
  { id: 'account.status', page: 'account', role: 'text', label: '账户状态提示', layout: { x: 16, y: 352, width: 358, height: 44 }, zIndex: 4, notes: '安卓用 TextView，错误状态使用 danger 色' },
];

export function accountMeta(id: string): ComponentMetaInput {
  const found = ACCOUNT_COMPONENTS.find((meta) => meta.id === id);
  if (found === undefined) throw new Error(`[account] 未登记的部件：${id}`);
  return found;
}

export function contentStyle(layout: BoxLayout): CSSProperties {
  return { position: 'absolute', left: layout.x, top: layout.y - 24, width: layout.width, height: layout.height };
}
